import type { UserVariableDefinitionValueTypeName } from '@/features/userVariable/dataType'
import * as v from 'valibot'

const nameSchema = v.pipe(
  v.string(),
  v.trim(),
  v.nonEmpty('必須です'),
  v.maxLength(255, '255文字以内で入力してください')
)

const selectOptionsSchema = v.pipe(
  v.array(
    v.object({
      key: v.string(),
      value: v.pipe(v.string(), v.trim()),
    })
  ),
  v.filterItems(item => item.value.length > 0),
  v.minLength(2, '選択肢を2つ以上入力してください')
)

export const formSchemaRecord = {
  UserVariableDefinitionValueString: v.object({
    name: nameSchema,
    dataType: v.literal<UserVariableDefinitionValueTypeName>(
      'UserVariableDefinitionValueString'
    ),
  }),
  UserVariableDefinitionValueText: v.object({
    name: nameSchema,
    dataType: v.literal<UserVariableDefinitionValueTypeName>(
      'UserVariableDefinitionValueText'
    ),
  }),
  UserVariableDefinitionValueSelect: v.object({
    name: nameSchema,
    dataType: v.literal<UserVariableDefinitionValueTypeName>(
      'UserVariableDefinitionValueSelect'
    ),
    selectOptions: selectOptionsSchema,
  }),
  UserVariableDefinitionValueMultipleSelect: v.object({
    name: nameSchema,
    dataType: v.literal<UserVariableDefinitionValueTypeName>(
      'UserVariableDefinitionValueMultipleSelect'
    ),
    selectOptions: selectOptionsSchema,
  }),
} satisfies Record<UserVariableDefinitionValueTypeName, v.GenericSchema>
